import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UpdateOilStoreDto, OilStoreService } from 'services/openapi';

export const useUpdateOilStoreMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: { id: string; data: UpdateOilStoreDto }) =>
      OilStoreService.oilStoreControllerUpdate(variables.id, variables.data),
  });
};
